module.exports = new __parcel__URL__("../diana.26ceab4d.png").toString();